// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem("yoles_token", data.token);
        await refreshUser();
        toast.success(`Bienvenue ${data.user.name} !`);
        // Clean hash from URL
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch (e) {
        toast.error(formatApiError(e));
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refreshUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-[color:var(--seafoam)]">
      <Loader2 className="h-8 w-8 animate-spin text-[color:var(--coral)]" />
      <div className="text-sm text-slate-500">Connexion Google en cours…</div>
    </div>
  );
}
